export default {
    text: "Hello~"
}